export default function FAIcon({ iconName, className="" }: { iconName: string, className?: string }) {
    return <i className={`fas fa-${iconName} ${className}`} />
}
